import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import Button from '../../Shared/components/controls/Button';
import { withTranslation } from 'react-i18next';
import './style.scss';

const ResultsNotFound = ({ props, name, reset: resetFiltersCallback }) => {
  const { noResultTitle: title2, noResultText: text2, noResultIcon: icon2 } = props?.fields;
  const { t } = props;
  //render params
  const shouldRenderIcon2 = !!icon2?.value?.src;
  const shouldRenderTile2 = !!title2?.value;
  const shouldRenderText2 = !!text2?.value;
  const shouldRenderLink = !!name && name !== '';
  return (
    <div className="no-results-found">
      <div className="panel right">
        <div className="wrap flex-it_ flex-align-item-center_ flex-justify-center_">
          <table className="fullTable">
            <tbody>
              <tr valign="middle">
                <td>
                  <div className="auto">
                    {shouldRenderIcon2 && <Image field={icon2} className="logo" />}
                    {shouldRenderTile2 && <RichText className="title" field={title2} />}
                    {shouldRenderText2 && <RichText className="description" field={text2} />}
                    {shouldRenderLink && (
                      <Button
                        onClick={() => {
                          resetFiltersCallback();
                        }}
                        variant="contained"
                        className="panel-right__link"
                        fullWidth={false}
                      >
                        {t('offerCategoryFilterResetButton').replace('{0}', name)}
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(ResultsNotFound);
